import { Component, Inject, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Vessel } from 'anchor-shared/lib/model/entity/vessel';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

@Component({
  selector: 'app-booking-description-dialog',
  templateUrl: './booking-description-dialog.component.html',
  styleUrls: ['./booking-description-dialog.component.scss'],
})
export class BookingDescriptionDialogComponent implements OnInit {
  vessel: Vessel;

  parsedMainDesc: SafeHtml;
  parsedAdminDesc1: SafeHtml;
  parsedAdminDesc2: SafeHtml;

  constructor(
    public dialogRef: MatDialogRef<BookingDescriptionDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private sanitizer: DomSanitizer,
  ) {
    this.vessel = data.vessel;
  }

  ngOnInit(): void {
    if (this.vessel.description) {
      this.parsedMainDesc = this.sanitizer.bypassSecurityTrustHtml(
        this.vessel.description,
      );
    }

    if (this.vessel.adminBuyflowText1) {
      this.parsedAdminDesc1 = this.sanitizer.bypassSecurityTrustHtml(
        this.vessel.adminBuyflowText1,
      );
    }

    if (this.vessel.adminBuyflowText2) {
      this.parsedAdminDesc2 = this.sanitizer.bypassSecurityTrustHtml(
        this.vessel.adminBuyflowText2,
      );
    }
  }
}
